export const  TOGGLE_COLUMN = "TOGGLE_COLUMN"
export const INITIALIZE_LAYOUT = "INITIALIZE_LAYOUT"